// Shared by the dashboard and its day by day page (DailyIncome.js)

export const money = (value, options) =>
  `${new Intl.NumberFormat("mn-MN", options).format(value || 0)} ₮`;

export const formatCount = (value) => new Intl.NumberFormat("mn-MN").format(value || 0);

// 12,500 as 12.5K, for an axis
export const compact = (value) =>
  new Intl.NumberFormat("mn-MN", { notation: "compact" }).format(value);

const WEEKDAYS = ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"];
// "YYYY-MM-DD" is read as UTC, so the weekday is that day's in any browser
export const weekdayOf = (day) => WEEKDAYS[new Date(day).getUTCDay()];
export const isWeekend = (day) => [0, 6].includes(new Date(day).getUTCDay());

// The daily target of the Plan page (GET /api/plan), or 0 when it has none. Both
// count income the same way: what refunds left.
export const dayTargetOf = (plan) => Number(plan?.levels?.target?.day) || 0;

// How far the income of so many days is from their target, in words
export const targetNote = (income, target, days) => {
  const name = days === 1 ? "Өдрийн" : `${days} өдрийн`;
  const percent = `${Math.round((income / target) * 100)}%`;
  return income >= target
    ? `${name} зорилтод хүрсэн · ${percent}`
    : `${name} зорилтын ${percent} · ${money(target - income)} дутуу`;
};

// What the kiosks of a day by day report (GET /api/monitoring/income/daily) brought
// together on each of its days, with the page bundles sold on the site those days,
// which are income of no kiosk
export const dayTotalsOf = ({ days, kiosks, bundles }) =>
  days.map((day, index) =>
    kiosks.reduce((sum, kiosk) => sum + kiosk.days[index], bundles ? bundles.days[index] || 0 : 0)
  );
